import axios from "axios"
import * as actions from "./actionsType"
import messages from "../../messages"
import toastr from "toastr"
import EducationLevelServices from "./EducationLevel.services"

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  export const getEducationLevel = (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: true,
      });
      const resp = await EducationLevelServices.getEducationLevel(filters);
      dispatch({
        type: actions.GET_EDUCATION_LEVEL,
        payload: {
          educationLevels: resp.data.data,
          educationLevelsLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: false,
      });
    }
  };
  
  export const getEducationLevelById = (id) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: true,
      });
      const resp = await EducationLevelServices.getEducationLevelByID(id);
      dispatch({
        type: actions.GET_EDUCATION_LEVEL,
        payload: {
          educationLevels: resp.data,
        },
      });
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: false,
      });
    }
  };
  
  export const saveEducationLevel =
    (data, setShowModal) => async (dispatch, getState) => {
      try {
        dispatch({
          type: actions.SAVE_LOADING_EDUCATION_LEVEL,
          payload: true,
        });
        const resp = await EducationLevelServices.saveEducationLevel(data);
        const { educationLevels, educationLevelsLength } = getState().educationLevel;
        const _educationLevels = [...educationLevels, resp.data];
        dispatch({
          type: actions.GET_EDUCATION_LEVEL,
          payload: {
            educationLevels: _educationLevels,
            educationLevelsLength: educationLevelsLength + 1,
          },
        });
        dispatch({
          type: actions.FORM_FAIL,
          payload: "",
        });
        setShowModal(false);
        toastr.success(messages.successMessage, " ", {
          progressBar: true,
          rtl: true,
        });
      } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
          if (ex.response?.status) {
            switch (ex.response.status) {
              case 400:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 404:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 500:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              default:
                message = ex.response.data;
                break;
            }
          } else {
            message =
              ex.message === "Network Error" ? messages.networkError : ex.message;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
          type: actions.FORM_FAIL,
          payload: message,
        });
      } finally {
        dispatch({
          type: actions.SAVE_LOADING_EDUCATION_LEVEL,
          payload: false,
        });
      }
    };
  
  export const editEducationLevel =
    (data, id, index, setShowModal) => async (dispatch, getState) => {
      try {
        dispatch({
          type: actions.LOADING_EDUCATION_LEVEL,
          payload: true,
        });
        const resp = await EducationLevelServices.editEducationLevel(id, data);
        const { educationLevels, educationLevelsLength } = getState().educationLevel;
        educationLevels[index] = resp.data;
        dispatch({
          type: actions.GET_EDUCATION_LEVEL,
          payload: {
            educationLevels: educationLevels,
            educationLevelsLength: educationLevelsLength,
          },
        });
        dispatch({
          type: actions.FORM_FAIL,
          payload: "",
        });
        setShowModal(false);
  
        toastr.success(messages.successMessage, " ", {
          progressBar: true,
          rtl: true,
        });
      } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
          if (ex.response?.status) {
            switch (ex.response.status) {
              case 400:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 404:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 500:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              default:
                message = ex.response.data;
                break;
            }
          } else {
            message =
              ex.message === "Network Error" ? messages.networkError : ex.message;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
          type: actions.FORM_FAIL,
          payload: message,
        });
      } finally {
        dispatch({
          type: actions.LOADING_EDUCATION_LEVEL,
          payload: false,
        });
      }
    };
  
  export const deleteEducationLevel = (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: true,
      });
      await EducationLevelServices.deleteEducationLevel(id);
      const { educationLevels, educationLevelsLength } = getState().educationLevel;
      educationLevels.splice(index, 1);
      dispatch({
        type: actions.GET_EDUCATION_LEVEL,
        payload: {
          educationLevels: educationLevels,
          educationLevelsLength: educationLevelsLength - 1,
        },
      });
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: "",
      });
  
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
  
      dispatch({
        type: actions.EDUCATION_LEVEL_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EDUCATION_LEVEL,
        payload: false,
      });
    }
  };
  